export const BRAND = {
  orange: "#E65A00",
  orangeHover: "#CC5000",
  orangeLight: "rgba(230, 90, 0, 0.08)",
  navy: "#1A2B4A",
  navyDark: "#152238",
  text: "#374151",
  muted: "#64748B",
  border: "#E5E7EB",
  bg: "#F8FAFC",
  success: "#16A34A",
};

export const LAYOUT = {
  cardRadius: "16px",
  cardShadow: "0 4px 24px rgba(0,0,0,0.06)",
  headerHeight: 64,
};

export const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "#fff",
    transition: "box-shadow 0.2s, border-color 0.2s",
    "& fieldset": { borderColor: BRAND.border },
    "&:hover fieldset": { borderColor: "#CBD5E1" },
    "&.Mui-focused fieldset": {
      borderColor: BRAND.orange,
      borderWidth: "1.5px",
    },
    "&.Mui-focused": {
      boxShadow: `0 0 0 3px ${BRAND.orangeLight}`,
    },
  },
  "& .MuiInputAdornment-root .MuiSvgIcon-root": {
    color: BRAND.muted,
    fontSize: "1.2rem",
  },
};

export const primaryButtonSx = {
  bgcolor: BRAND.orange,
  color: "#fff",
  py: 1.5,
  borderRadius: "10px",
  fontWeight: 600,
  fontSize: "0.95rem",
  letterSpacing: "0.02em",
  textTransform: "none",
  transition: "background-color 0.2s, transform 0.15s, box-shadow 0.2s",
  "&:hover": {
    bgcolor: BRAND.orangeHover,
    boxShadow: "0 4px 14px rgba(230,90,0,0.35)",
  },
  "&:active": { transform: "scale(0.99)" },
  "&.Mui-disabled": {
    bgcolor: "#E5E7EB",
    color: BRAND.muted,
  },
};

export const secondaryButtonSx = {
  py: 1.5,
  borderRadius: "10px",
  fontWeight: 600,
  fontSize: "0.95rem",
  textTransform: "none",
  borderColor: BRAND.navy,
  color: BRAND.navy,
  "&:hover": {
    borderColor: BRAND.navy,
    bgcolor: "rgba(26, 43, 74, 0.06)",
  },
};

export const cardSx = {
  bgcolor: "#fff",
  borderRadius: LAYOUT.cardRadius,
  border: `1px solid ${BRAND.border}`,
  boxShadow: LAYOUT.cardShadow,
  p: { xs: 1.5, sm: 3, md: 4 },
  overflow: "hidden",
};

export const kioskCardSx = {
  ...cardSx,
  borderRadius: { xs: "12px", sm: LAYOUT.cardRadius },
  boxShadow: { xs: "0 2px 12px rgba(0,0,0,0.05)", sm: LAYOUT.cardShadow },
};

export const kioskInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    fontSize: "1.25rem",
    fontWeight: 600,
    letterSpacing: "0.04em",
  },
  "& .MuiInputLabel-root": {
    fontWeight: 500,
  },
};

export const punchInButtonSx = {
  ...primaryButtonSx,
  py: 2,
  fontSize: "1.05rem",
  fontWeight: 700,
  borderRadius: "12px",
  boxShadow: "0 4px 16px rgba(230,90,0,0.25)",
};

export const punchOutButtonSx = {
  ...secondaryButtonSx,
  py: 2,
  fontSize: "1.05rem",
  fontWeight: 700,
  borderRadius: "12px",
  borderWidth: 2,
  "&:hover": {
    borderWidth: 2,
    borderColor: BRAND.navy,
    bgcolor: "rgba(26, 43, 74, 0.06)",
  },
};

